'use client';

import Button, { type ButtonProps } from '@carvana/ds-button';
import useIsHydrated from '~/hooks/common/useIsHydrated';

// Server-renders disabled so a click before React attaches handlers can't be a dead click.
export default function HydrationGatedButton({
  disabled,
  ...props
}: ButtonProps) {
  const isHydrated = useIsHydrated();

  return <Button disabled={disabled || !isHydrated} {...props} />;
}
